<template>
  <div :style="{ 'background-color':'#F7F7F7', height: '100vh' }" id="outermost">
    <van-nav-bar
      :title="companyName"
      left-text="返回"
      left-arrow
      @click-left="back()"
      id="topbar"
    />
    <div class="bgDiv" style="position: fixed;top:46px;"></div>
    <div style="padding:20px;" class="mainDiv">
      <div>
        <div class="infoTit">基本信息</div>
        <div class="infoDiv" @click="toCompanyInfo">
          <van-row type="flex" justify="space-between" align="center">
            <van-col style="display:flex;align-items:center;">
              <img class="infoIcon" src="../../assets/project/companyIcon.png">
              <div class="infoText">
                <div>{{ companyInfo.companyName }}</div>
                <div>{{ companyInfo.industryName }}</div>
              </div>
            </van-col>
            <van-col>
              <img class="rightIcon" src="../../assets/project/right.png">
            </van-col>
          </van-row>
        </div>
      </div>
      <div style="margin-top:20px;">
        <div class="infoTit2">现场核查</div>
        <div class="infoDiv" style="padding:0px;">
          <div class="xchc">
            <div>上次核查时间:
              <span v-if="companyInfo.lastWorkTime">{{ companyInfo.lastWorkTime }}</span>
              <span v-else>无</span>
            </div>
            <div>核查次数:<span>{{ companyInfo.workCount }}</span>次</div>
          </div>
          <div class="kshc">
            <van-button color="#1B75F6"
                        @click="toVerification"
                        :loading="historyRecordsState.isLoading"
                        :disabled="historyRecordsState.isLoading">
              开始核查
            </van-button>
          </div>
        </div>
      </div>
      <div style="margin-top: 10px;">
        <div class="infoTit2">更多功能</div>
        <div>
          <van-row type="flex" justify="space-between">
            <van-col span="7" class="others" @click="toWorkRecords">
              <img class="infoIcon" src="../../assets/project/listIcon.png" style="width: 50px; height: 50px;">
              <div style="margin-top:10px;">核查记录</div>
            </van-col>
            <van-col span="7" class="others" @click="toProblem">
              <img class="infoIcon" src="../../assets/project/cameraIcon.png" style="width: 50px; height: 50px;">
              <div style="margin-top:10px;">现场问题</div>
            </van-col>
            <!--              <van-col span="7" class="others" @click="$router.push({ name: 'project-problemCache' })">-->
            <!--                <img class="infoIcon" src="../../assets/project/temp-save.png" style="width: 50px; height: 50px;">-->
            <!--                <div style="margin-top:10px;">问题暂存</div>-->
            <!--              </van-col>-->
            <van-col span="7" class="others" @click="toProblemCheckTask">
              <img class="infoIcon" src="../../assets/project/listIcon.png" style="width: 50px; height: 50px;">
              <div style="margin-top:10px;">问题检查记录</div>
            </van-col>
          </van-row>
          <van-row type="flex" justify="space-between" style="margin-top: 10px">
            <van-col span="7" class="others" @click="toProblemFollow">
              <img class="infoIcon" src="../../assets/project/followIcon.png" style="width: 50px; height: 50px;">
              <div style="margin-top:10px;">问题跟踪</div>
            </van-col>
            <van-col span="7" class="others" @click="toCompanyArchives">
              <img class="infoIcon" src="../../assets/project/companyArchives.png" style="width: 50px; height: 50px;">
              <div style="margin-top:10px;">一企一档</div>
            </van-col>
            <van-col span="7"/>
          </van-row>
        </div>
      </div>
    </div>
    <div>
      <van-popup v-model="copyRecord.showPicker"
                 :close-on-click-overlay="false"
                 round position="bottom"
                 :style="{ height: '40%' ,width: '100%' }">
        <van-picker
          class="copy-picker"
          :title="'\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0选择复制的记录时间'"
          show-toolbar
          :loading="copyRecord.loading"
          :columns="copyRecord.columns"
          :visible-item-count="6"
          cancel-button-text=" "
          @confirm="onConfirm"
        />
      </van-popup>
    </div>
  </div>
</template>
<script>
import $ from '@/fly'
import {WorkRecordsStore} from "@/libs/indexedDB";
import {Dialog, Toast} from "vant";

export default {
  name: 'project-companyOperation',
  data() {
    return {
      projectId: null,
      companyId: '',
      companyName: '',
      companyInfo: {},
      copyRecord:{
        columns: [],
        showPicker:false,
        loading:false,
        recordsList:[]
      },
      historyRecordsState:{
        isLoading:false,
      }
    }
  },
  async created() {
    this.initBaseData();
    await this.loadInfo();
  },
  methods: {
    // 初始化基础数据
    initBaseData() {
      this.projectId = localStorage.getItem('projectId')
      this.companyId = localStorage.getItem('companyId');
      this.companyName = localStorage.getItem('companyName');
    },
    // 返回上一页
    back(){
      this.$router.push({name: 'project-companyList'})
    },
    // 加载企业信息
    async loadInfo() {
      try {
        const res = await $.get('company/findById', {
          companyId: this.companyId,
          projectId: this.projectId
        });
        this.companyInfo = res || {};
      } catch (error) {
        Toast.fail('加载企业信息失败');
      }
    },
    // 跳转到企业详情
    toCompanyInfo() {
      localStorage.setItem('companyInfo', this.companyInfo);
      this.$router.push({name: 'project-companyInfo'});
    },
    // 跳转到问题检查记录
    toProblemCheckTask() {
      this.$router.push({name: 'project-problemCheckTask'});
    },
    // 开始核查
    async toVerification() {

      if (this.historyRecordsState.isLoading) return;

      await this.getHistoryRecords()

      if (this.copyRecord.recordsList.length > 0) {
        await this.handleCopyConfirm();
      } else {
        await this.navigateToVerification('0', null);
      }
    },
    //获取核查记录列表
    async getHistoryRecords(){
      this.historyRecordsState.isLoading = true;
      try {
        this.copyRecord.recordsList = await $.get('workRecords/getByProjectCompany', {
          companyIds: this.companyId,
        });
      } catch (err) {
        this.copyRecord.recordsList = [];
        Toast('获取历史记录失败');
      } finally {
        this.historyRecordsState.isLoading = false;
      }
    },
    //处理是否复制历史记录确认框
    async handleCopyConfirm(){
      try {
        const confirmResult = await Dialog.confirm({
          title: '提示',
          message: '是否需要复制最近一次核查记录？',
          confirmButtonText: '是',
          cancelButtonText: '否'
        });
        if (confirmResult) {
          // this.copyRecord.showPicker = true;
          // this.copyRecord.loading = true;
          this.copyRecord.columns = this.copyRecord.recordsList.map(item => ({
            text: item.signTime,
            value: item.id
          }));

          //确定后直接复制第一条
          await this.onConfirm(this.copyRecord.columns[0] || null)
        }
      } catch (error) {
        if (error === 'cancel') {
          await this.navigateToVerification('0', null);
        } else {
          Toast.fail({
            message: '加载记录异常，请重试！',
            duration: 3000
          });
        }
      } finally {
        // this.copyRecord.loading = false;
      }
    },
    //确认复制记录
    async onConfirm(obj) {
      // this.copyRecord.showPicker = false;
      if (obj) {
        await this.navigateToVerification('3', this.copyRecord.recordsList.find( item => item.id === obj.value ));
      } else {
        await this.navigateToVerification('0', null);
        Toast('记录未复制,开始初始加载...');
      }
    },
    // 统一处理跳转核查页面逻辑
    async navigateToVerification(isCache, copyRecord) {
      try {
        const baseWorkData = {
          projectId: this.projectId,
          companyId: this.companyId,
          cacheCode: ""
        };
        const addSuccess = await WorkRecordsStore.add(baseWorkData);
        if (!addSuccess) throw new Error('初始化核查记录失败');

        const latestWork = (await WorkRecordsStore.toArray()).sort((f, s) => s.id - f.id)[0];
        // 存储必要参数
        localStorage.setItem('isCacheWork', isCache);
        localStorage.setItem('indexdbCacheId', latestWork?.id || '');
        if (isCache==='3' && copyRecord) {
          Toast.success('复制记录数据完成');
          localStorage.setItem('workRecordItem', JSON.stringify(copyRecord));
        } else {
          localStorage.removeItem('workRecordItem');
        }
        await this.$router.push({ name: 'project-companyVerification' });
      } catch (error) {
        localStorage.removeItem('isCacheWork');
        localStorage.removeItem('indexdbCacheId');
        localStorage.removeItem('workRecordItem');
        Toast.fail('初始加载失败');
      }
    },
    // 跳转到核查记录
    toWorkRecords() {
      this.$router.push({name: 'project-workRecords'});
    },
    // 跳转到现场问题
    async toProblem() {
      try {
        const userId = JSON.parse(localStorage.getItem('USER')).userId
        const res = await $.post('problemCheckTask', {
          checkUserId: userId,
          companyId: this.companyId,
          projectId: this.projectId,
          submitStatus: 0
        });
        localStorage.setItem('task', JSON.stringify(res))
        localStorage.setItem('problemIds', '')
        localStorage.removeItem('workRecordData')
        await this.$router.push({name: 'project-problemCheckTaskIndex'});
      } catch (error) {
        Toast.fail('初始化问题检查失败');
      }
    },
    // 跳转到问题跟踪
    toProblemFollow() {
      this.$router.push({name: 'project-problemFollow'});
    },
    // 跳转一企一档
    toCompanyArchives() {
      this.$router.push({name: 'project-companyArchives'});
    }
  },
}

</script>

<style lang="less" scoped>
.bgDiv {
  width: 100%;
  min-height: 260px;
  background-color: #1B75F6;
}

.mainDiv {
  position: fixed;
  top: 150px;
  width: 100%;
}

.infoTit {
  color: #FFFFFF;
  font-size: 30px;
  font-weight: bold;
}

.infoTit2 {
  color: #96ABC9;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 25px;
}

.infoIcon {
  width: 120px;
  vertical-align: middle;
}

.infoDiv {
  background-color: #FFFFFF;
  width: 100%;
  padding: 30px;
  margin-top: 25px;
  border-radius: 5px;
  box-shadow: #7893ff45 0px 0px 35px;
}

.rightIcon {
  width: 25px;
}

.infoText {
  margin-left: 20px;
}

.infoText div:first-child, .xchc div {
  color: #242E42;
  font-size: 26px;
  font-weight: bold;
  line-height: 56px;
  letter-spacing: 1px;
}

.infoText div:last-child {
  color: #C8C7CC;
  font-size: 26px;
  font-weight: bold;
  line-height: 56px;
}

.xchc {
  border-bottom: 1px solid #EFEFEF;
  padding: 15px 30px;
}

.kshc {
  text-align: center;
  padding: 20px 30px;
}

.kshc .van-button {
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  border-radius: 6px;
  width: 140px;
}

.others {
  background-color: #FFFFFF;
  padding: 30px 10px;
  border-radius: 5px;
  box-shadow: #7893ff45 0px 0px 35px;
  text-align: center;
  height: 200px;
  color: #242E42;
  font-size: 26px;
  font-weight: bold;
}
.copy-picker {
  /deep/.van-picker__title{
    color: rgba(34, 35, 35, 0.8) !important;
  }
}
</style>
